import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  filter: {
    // background: 'white',
    border: '1px solid rgb(224 224 224)',
    borderRadius: '.4rem',
    padding: '0 .5rem',
    borderBottom: 'none',
  },
  filter_header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: '1rem',
  },
  cardLayout: {
    // marginBottom: 10,
  },
}));

export default useStyles;
